<template>
  <div class="myCounselor">
    <div class="contentside">
      <div class="avaterWrapper" :style="{ backgroundImage: `url(${agentInfo.idCardAbsolutePath})` }" />
      <h3 class="agentname">{{ agentInfo.name }}</h3>
      <div class="appoint" :class="iconIndex == 0 ? 'on' : ''" @click="handleAppoint" @mouseover="changeActive(0)">
        <span class="appointIcon"></span>
        预约顾问
      </div>
      <div class="tel" :class="iconIndex == 1 ? 'on' : ''" @click="handleTelclick" @mouseover="changeActive(1)">
        <span class="telIcon"></span>
        致电顾问
      </div>
      <div class="wx" :class="iconIndex == 2 ? 'on' : ''" @click="handleWxclick" @mouseover="changeActive(2)">
        <span class="wxIcon"></span>
        微信联系
      </div>
    </div>
    <div class="content">
      <div class="nameWrapper">
        <h3 class="name">{{ agentInfo.name }}</h3>
        <div v-if="agentInfo.professionClass" class="professionClass">
          <span
            v-for="(item, index) in changeDicto(agentInfo.professionClass, professionClass, true)"
            :key="index + 'professionClass'"
          >
            {{ item }}
          </span>
        </div>
        <div class="like">
          <span class="thumb" :class="!flag ? 'off' : ''" @click="togglezan"></span>
          <span class="likeNumber" :class="!flag ? 'off' : ''">{{ agentInfo.likeNumber }}</span>
        </div>
      </div>
      <div class="infoitem" v-if="agentInfo.companyName">
        <span>所属公司</span>
        <p>{{ agentInfo.companyName }}</p>
      </div>
      <div class="infoitem" v-if="agentInfo.credentialCode">
        <span>执业证编码</span>
        <p>{{ agentInfo.credentialCode }} <b class="verify" @click="verify">验证 </b></p>
      </div>
      <div class="infoitem" v-if="agentInfo.honourAndCredentials">
        <span>荣誉</span>
        <p>{{ changeDicto(agentInfo.honourAndCredentials, honor) }}</p>
      </div>
      <div class="infoitem" v-if="agentInfo.skiiledFields">
        <span>擅长领域</span>
        <p>{{ changeDicto(agentInfo.skiiledFields, skilled) }}</p>
      </div>
      <div class="infoitem" v-if="agentInfo.introduction">
        <span>个人介绍</span>
        <p v-html="agentInfo.introduction"></p>
      </div>
    </div>
    <Mycounselor ref="Mycounselor" :agentCode="agentInfo.code" />
    <el-dialog
      :visible.sync="telpopShow"
      width="322px"
      :show-close="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <span class="dialog-close" @click="telpopShow = false" />
      <p class="poptitle">请拨打下方号码，联系您的专属顾问</p>
      <div class="telpopWrapper">
        <span class="avatar" :style="{ backgroundImage: `url(${agentInfo.idCardAbsolutePath})` }" alt="" />
        <span>{{ agentInfo.phoneNo | formatPhone }}</span>
      </div>
      <div class="rightnow">
        <span @click="closeDialog">确认</span>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="wxpopShow"
      width="314px"
      :show-close="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <span class="dialog-close" @click="wxpopShow = false" />
      <p class="poptitle">微信扫描二维码添加顾问微信</p>
      <div class="qrcodeWrapper">
        <img class="qrcode" :src="agentInfo.wechatQrCodeAbsolutePath" alt="" />
      </div>

      <div class="rightnow">
        <span @click="closeDialog">确认</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { queryCounselor, cancelLike, addLike } from '@/api/firstpage';
import { queryDic } from '@/api/BSC';
export default {
  data() {
    return {
      agentInfo: {},
      //职称
      professionClass: [],
      honor: [],
      skilled: [],
      flag: false,
      wxpopShow: false,
      telpopShow: false,
      iconIndex: null,
    };
  },
  methods: {
    handleAppoint() {
      this.$refs.Mycounselor.init();
    },
    // 字典查询
    async getDics() {
      this.skilled = this.$store.state.dicMap['bbc.skiiledFields']
        ? this.$store.state.dicMap['bbc.skiiledFields']
        : await queryDic({ dicCode: 'bbc.skiiledFields' });
      this.honor = this.$store.state.dicMap['bbc.honourAndCredentials']
        ? this.$store.state.dicMap['bbc.honourAndCredentials']
        : await queryDic({ dicCode: 'bbc.honourAndCredentials' });
      this.professionClass = this.$store.state.dicMap['bbc.professionClass']
        ? this.$store.state.dicMap['bbc.professionClass']
        : await queryDic({ dicCode: 'bbc.professionClass' });
    },
    async getInfo() {
      let res = await queryCounselor({
        enterpriseId: this.$store.state.user.user.defaultEnterpriseId,
        customerName: this.$store.state.user.user.name,
        certificatesNum: this.$store.state.user.user.idCardNo,
      });
      if (res && res.name) {
        this.agentInfo = res;
        this.flag = res.liked;
      }
    },
    changeDicto(code, arry, tostring = false) {
      let list = [];
      let codeArry = code.split(',');
      arry.map(item => {
        codeArry.map(a => {
          if (item.dicItemCode == a) {
            list.push(item.dicItemName);
          }
        });
      });
      return tostring ? list : list.join(',');
    },
    togglezan() {
      let flag = this.flag;
      if (flag) {
        //已经点赞
        cancelLike({
          consultantId: this.agentInfo.consultantId,
          name: this.$store.state.user.user.name,
        }).then(res => {
          if (res) {
            this.agentInfo.likeNumber--;
            this.flag = !this.flag;
          }
        });
      } else {
        //未点赞
        addLike({
          consultantId: this.agentInfo.consultantId,
          name: this.$store.state.user.user.name,
        }).then(res => {
          if (res) {
            this.flag = !this.flag;
            this.agentInfo.likeNumber++;
          }
        });
      }
    },
    verify() {
      window.open('https://www.insurcloud.com.cn');
    },
    handleTelclick() {
      this.telpopShow = true;
    },
    handleWxclick() {
      this.wxpopShow = true;
    },
    closeDialog() {
      this.telpopShow = false;
      this.wxpopShow = false;
    },
    changeActive(index) {
      this.iconIndex = index;
    },
  },
  created() {
    this.getInfo();
    this.getDics();
  },
};
</script>
<style lang="less" scoped>
.myCounselor {
  display: flex;
  max-width: @contentWidth;
  height: 530px;
  margin: 0 auto;
  margin-top: 16px;
  border: 1px solid #dcdce1;
  .contentside {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 200px;
    background: #fafafa;
    .avaterWrapper {
      position: relative;
      top: 0;
      box-sizing: border-box;
      width: 96px;
      height: 96px;
      margin: 34px 0 14px;
      border: 2px solid white;
      border-radius: 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      transition: 0.3s;
      &:hover {
        top: -6px;
      }
    }
    .agentname {
      margin-bottom: 24px;
      font-size: 22px;
      font-weight: bold;
      color: #55555a;
    }
    .appoint,
    .tel,
    .wx {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 140px;
      height: 34px;
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 400;
      line-height: 34px;
      color: #e27c00;
      border: 1px solid #e27c00;
      background: #fafafa;
      cursor: pointer;
      text-align: center;
      > span {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
      &.on {
        color: #fff;
        background: #e27c00;
        .appointIcon {
          background: url(~@/assets/imgs/agentclockicon.png) no-repeat center center;
        }
        .telIcon {
          background: url(~@/assets/imgs/agentphoneicon.png) no-repeat center center;
        }
        .wxIcon {
          background: url(~@/assets/imgs/agentwxicon.png) no-repeat center center;
        }
      }
      .appointIcon {
        background: url(~@/assets/imgs/agentclockicon-on.png) no-repeat center center;
      }
      .telIcon {
        background: url(~@/assets/imgs/agentphoneicon-on.png) no-repeat center center;
      }
      .wxIcon {
        background: url(~@/assets/imgs/agentwxicon-on.png) no-repeat center center;
      }
    }
  }
  .content {
    flex: 1;
    padding: 0 20px;
    .nameWrapper {
      display: flex;
      align-items: center;
      height: 67px;
      border-bottom: 1px solid #dcdce1;
      .name {
        margin-right: 20px;
        font-size: 22px;
        font-weight: 500;
        color: #55555a;
      }
      .professionClass {
        font-size: 16px;
        font-weight: 400;
        color: #aaaaaf;
      }
      .like {
        margin-left: auto;
        .thumb {
          display: inline-block;
          display: inline-block;
          width: 23px;
          height: 22px;
          margin-right: 6px;
          margin-left: 22px;
          background: url('../../assets/imgs/zan-on.png');
          background-size: cover;
          cursor: pointer;
          &.off {
            background: url('../../assets/imgs/zan-off.png');
            background-size: cover;
          }
        }
        .likeNumber {
          font-size: 14px;
          color: #e39400;
          &.off {
            color: #aaaaaf;
          }
        }
      }
    }
    .infoitem {
      display: flex;
      margin-top: 20px;
      span {
        width: 150px;
        font-size: 14px;
        font-weight: 400;
        color: #aaaaaf;
      }
      p {
        flex: 1;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #55555a;
        .verify {
          font-size: 14px;
          font-weight: 400;
          line-height: 14px;
          color: #e27c00;
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
  /deep/ .el-dialog {
    .dialog-close {
      position: absolute;
      width: 16px;
      height: 16px;
      background: url(~@/assets/imgs/closeIcon.png) no-repeat;
      background-size: 100% 100%;
      right: 20px;
      top: 20px;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        color: #e27c00;
        opacity: 0.6;
      }
    }
  }
}
.poptitle {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  color: #55555a;
  text-align: center;
}
.telpopWrapper {
  display: flex;
  align-items: center;
  width: 223px;
  height: 66px;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.09);
  .avatar {
    width: 42px;
    height: 42px;
    margin-left: 12px;
    border-radius: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  span {
    margin-left: 23px;
    font-size: 16px;
    font-weight: 400;
    color: #e27c00;
  }
}
.rightnow {
  margin-top: 30px;
  text-align: center;
  span {
    display: inline-block;
    width: 200px;
    height: 34px;
    font-size: 16px;
    font-weight: 500;
    line-height: 34px;
    color: #fff;
    border-radius: 2px;
    background: #e27c00;
    cursor: pointer;
  }
}
.qrcodeWrapper {
  box-sizing: border-box;
  width: 200px;
  height: 200px;
  margin: 0 auto;
  padding: 10px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.09);
  .qrcode {
    width: 180px;
    height: 180px;
  }
}
</style>
